import { computed, effect, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Cart, selectOrderId } from '../+state/cart.reducer';
import { distinctUntilChanged, filter, Subject } from 'rxjs';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { toSignal } from '@angular/core/rxjs-interop';
import { PusherEvent, PusherService } from '@us/web/websockets/data-access';
import { parseDataServer } from '@us/web/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class CartService {
    private readonly pusherService = inject(PusherService);
    private readonly store = inject(Store);

    private readonly orderId = toSignal(
        this.store.select(selectOrderId).pipe(filter(tuiIsPresent), distinctUntilChanged())
    );

    readonly cartChannel = computed(() => {
        const pusherClient = this.pusherService.pusherClient();
        const orderId = this.orderId();
        if (!pusherClient || !orderId) {
            return;
        }

        return pusherClient.subscribe(`presence-carts.${orderId}`);
    });

    readonly orderUpdated$ = new Subject<{ cart: Cart }>();

    private readonly orderChannelLog = effect(() => {
        const orderChannel = this.cartChannel();
        if (!orderChannel) {
            console.warn('No order channel created');
            return;
        }
        orderChannel.bind('pusher:subscription_succeeded', () => {
            console.log(`${orderChannel.name} subscription_succeeded`);
        });

        orderChannel.bind('pusher:subscription_error', (error: unknown) => {
            console.error(`${orderChannel.name} pusher:subscription_error`, error);
        });

        orderChannel.bind(PusherEvent.CART_UPDATED, ({ cart }: { cart: Cart }) => {
            console.log(PusherEvent.CART_UPDATED, cart);
            this.orderUpdated$.next({ cart: parseDataServer(cart) });
        });
    });
}
